
import { useStore } from "@/store";
import { defineComponent } from "vue";
import { marked } from "marked";

export default defineComponent({
  setup() {},
  computed: {
    summary() {
      return marked(useStore().state.summary);
    }
  }
});
